import { useEffect, useState } from 'react';
import { Seo } from '../lib/seo';
import { PageHero } from '../components/PageHero';
import { ProjectCard } from '../components/ProjectCard';
import { api } from '../lib/api';
import type { Project } from '../lib/types';
import { fallbackProjects } from '../lib/static-content';

export function PortfolioPage() {
  const [projects, setProjects] = useState<Project[]>(fallbackProjects);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    api
      .projects()
      .then((data) => {
        if (isMounted && Array.isArray(data) && data.length > 0) {
          setProjects(data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setProjects(fallbackProjects);
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Seo
        title="Portfólio"
        description="Projetos e soluções desenvolvidas pela A3GS Tec."
        path="/portfolio"
      />

      <PageHero
        eyebrow="PORTFÓLIO"
        title="Projetos que contam a história da A3GS Tec."
        description="Apresente sites, redes, servidores e outras soluções realizadas pela empresa."
      />

      <section className="section">
        <div className="container portfolio-grid">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              featured={index === 0}
            />
          ))}
        </div>
         
      </section>
    </>
  );
}